/**
 * Adds trailing slash to a string if it does not include one
 * @param {string} string The string to be formatted
 * @returns {string} String with a trailing slash
 */
export const setTrailingSlash = (string) => {
  const lastCharacter = string.slice(-1);
  if (lastCharacter === '/') {
    return string;
  }
  return `${string}/`;
};

export default setTrailingSlash;
